var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "py-3 px-4" },
    [
      _c(
        "v-card-title",
        { staticClass: "pb-2 pt-0", attrs: { "primary-title": "" } },
        [
          _c("h3", [_vm._v("Listing Company: ")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.bid.listing.listingCompany.name))])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _vm.hasOfficePermission(_vm.bid.listing) &&
          _vm.bid.status !== _vm.bidStatus.ACCEPTED
            ? _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md2: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Loads",
                          items: _vm._.range(
                            1,
                            _vm.bid.numberOfLoadsSelections + 1
                          ),
                          disabled: _vm.bid.status !== _vm.bidStatus.ACTIVE
                        },
                        model: {
                          value: _vm.bid.numberOfLoads,
                          callback: function($$v) {
                            _vm.$set(_vm.bid, "numberOfLoads", $$v)
                          },
                          expression: "bid.numberOfLoads"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "ml-2", attrs: { md9: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "accent",
                            disabled:
                              _vm.bid.status ===
                              _vm.bidStatus.CANCELLED_BY_BIDDER
                          },
                          on: {
                            click: function($event) {
                              return _vm.acceptBid(_vm.bid)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "pr-2", attrs: { dark: "" } },
                            [_vm._v("check_circle")]
                          ),
                          _vm._v("\n          Accept\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("bid-form", {
        attrs: { "hide-form": false, "disable-form": false, bid: _vm.bid },
        on: {
          refresh: function($event) {
            return _vm.$emit("refresh")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-290f9396", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290f9396","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BidDetails.vue
// module id = null
// module chunks = 